import { appV2EventPrefix } from "@src/appV2/lib/analytics/events";

export const EVIDENCE_DEFINITIONS_QUERY_KEY = "evidence-definitions";
export const WORKER_EVIDENCES_QUERY_KEY = "worker-evidences";
export const DOCUMENT_EVIDENCES_QUERY_KEY = "document-evidences";

export const EVIDENCE_SOURCE_TYPE = "FILE_UPLOAD" as const;

export const JSON_API_TYPES = {
  mongoDocument: "mongoDocument",
  worker: "worker",
} as const;

export const SUBMIT_LABELS = {
  createEvidence: { idle: "Create Evidence", submitting: "Creating..." },
  updateEvidence: { idle: "Update Evidence", submitting: "Updating..." },
} as const;

export const EVIDENCE_TABS = {
  existingDocuments: "existing-documents",
  evidences: "evidences",
} as const;

export type EvidenceTab = (typeof EVIDENCE_TABS)[keyof typeof EVIDENCE_TABS];

const evidencesToolPrefix = `${appV2EventPrefix} Evidences Tool`;

export const EVIDENCES_ANALYTICS_EVENTS = {
  PAGE_VIEWED: `${evidencesToolPrefix} Page Viewed`,
  TAB_SWITCHED: `${evidencesToolPrefix} Tab Switched`,
  WORKER_SEARCHED: `${evidencesToolPrefix} Worker Searched`,
  EVIDENCE_VIEW_CLICKED: `${evidencesToolPrefix} Evidence View Clicked`,
  DOCUMENT_VIEW_CLICKED: `${evidencesToolPrefix} Document View Clicked`,
  EVIDENCE_UPDATED: `${evidencesToolPrefix} Evidence Updated`,
  EVIDENCE_UPDATE_FAILED: `${evidencesToolPrefix} Evidence Update Failed`,
  EVIDENCE_EDIT_DISMISSED: `${evidencesToolPrefix} Evidence Edit Dismissed`,
  EVIDENCE_CREATED_FROM_DOCUMENT: `${evidencesToolPrefix} Evidence Created From Document`,
  EVIDENCE_CREATE_FROM_DOCUMENT_FAILED: `${evidencesToolPrefix} Evidence Create From Document Failed`,
  EVIDENCE_UPDATED_FROM_DOCUMENT: `${evidencesToolPrefix} Evidence Updated From Document`,
  EVIDENCE_UPDATE_FROM_DOCUMENT_FAILED: `${evidencesToolPrefix} Evidence Update From Document Failed`,
  DOCUMENT_REVIEW_DISMISSED: `${evidencesToolPrefix} Document Review Dismissed`,
} as const;
